(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('GroupSessionFormTpl', GroupSessionFormTpl);

    GroupSessionFormTpl.$inject = ['$resource'];

    function GroupSessionFormTpl ($resource) {
        var resourceUrl =  'api/group-session-form-tpls/:id';

        return $resource(resourceUrl, {}, {
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.jsonTemplate = angular.toJson(copy.jsonTemplate);
                    return angular.toJson(copy);
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.jsonTemplate = angular.fromJson(data.jsonTemplate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.jsonTemplate = angular.toJson(copy.jsonTemplate);
                    return angular.toJson(copy);
                }
            },
            'filter': {url: 'api/group-session-form-tpl/filter', method: 'GET', isArray: true},
            'clone': {url: 'api/group-session-form-tpl/clone/:id', method: 'GET'}
        });
    }
})();
